import React from "react";
import PropTypes from "prop-types";
import UserPhoto from "./UserPhoto";
import UserFullName from "./UserFullName";
import "./UserDetails.css"; // Import the CSS file

const UserDetails = ({ user }) => { 

  return (
    <div className="user-details">
      <UserPhoto
        photo={user.photo}
        firstName={user?.firstName}
        lastName={user?.lastName}
        sharedFirstName={user?.sharedFirstName}
        sharedLastName={user?.sharedLastName}
      />
      <div>
        <UserFullName
          name={user.name}
          firstName={user?.firstName}           
          lastName={user?.lastName}
            sharedFirstName={user?.sharedFirstName}
        sharedLastName={user?.sharedLastName}
        />
              <div className="user-organization" title={user.organization}>
          {user.organization || "No organization"}
        </div>
      </div>
    </div>
  );
};

UserDetails.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    photo: PropTypes.string,
    organization: PropTypes.string,
  }).isRequired,
};

export default UserDetails;